import { useParams } from "react-router-dom";
import { useBrands } from "../../core/hooks/useBrands";
import { useAuthorizedBrands } from "../../core/hooks/useAuthorizedBrands";
import { Module } from "../../ui/components/Module";
import { Trans } from "react-i18next";
import { ReactNode } from "react";

export const BrandGuard = ({children}: {children: ReactNode}) => {
  const {brandSlug} = useParams();
  const brands = useBrands();
  const authorizedBrands = useAuthorizedBrands();
  const brand = brands
    ?.find(b => brandSlug === b.urlSlug);
  const authorizedBrand = authorizedBrands
    ?.find(b => brandSlug === b.urlSlug);

  if (!brands) {
    return null;
  }

  if (!brand) {
    return (
      <Module>
        <Trans>Brand invalid</Trans>
      </Module>
    );
  }

  if (!authorizedBrand) {
    return (
      <Module>
        <Trans>Brand not authorized</Trans>
      </Module>
    );
  }

  return <>{children}</>;
};
